import http from '../jslibs/axios/http';

// 账号登录
export const login = data => http.post('/cms/login', data);

// 手机登录
export const MobileLogin = data => http.post('/cms/MobileLogin', data);

// 扫码登录
export const ScanLogin = data => http.post('/cms/ScanLogin', data);
// 素材库列表
// export const ScanLogin = data => http.post('/cms/ScanLogin', data);

//  获取阿里云oss地址
export const getOss = data => http.get('/cms/Communal', data);
//  传链接获取阿里云oss地址
export const getOssUrl = data => http.post('/common/UploadUrlImgPath', data);
// 后台管理-图片上传
export const Upload = (data, config) => http.post('/common/UploadFile', data, config || {});
// 地区选择字典
export const getAreaInfo = data => http.get('/web/getAreaInfo', data);
//  获取登录二维码
export const qRCodeLogin = data => http.get('/web/loginCode', {}, {
    headers: {
      'XX-Device-Type': 'scan',
    }
  });
//  获取登录二维码状态
export const getLoginStatus = data => http.get('/web/loginStatus', data, {
    headers: {
      'XX-Device-Type': 'scan',
    }
  });
